import React, { useState } from 'react';
import { FaLock, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import image from '../../assets/images/image.png';
import { toast } from 'react-hot-toast';
import ApiService from '../../models/ApiService';
import LocalData from '../../models/LocalData';
import { setLoggedUser } from '../../models/ApiService';

const Signin = ({ setsignininfo }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [SigninCrediential, setSigninCrediential] = useState({
        username: "",
        password: "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setSigninCrediential(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        // Validate fields
        if (!SigninCrediential.username || !SigninCrediential.password) {
            setError("Both username and password are required");
            toast.error("Please fill in all fields");
            return;
        }

        setLoading(true);

        try {
            const res = await ApiService.Signin(SigninCrediential);
            console.log(res);

            const local = res.data.responseContent;
            console.log(local);

            LocalData.setLoggedInfo(JSON.stringify(local));
            setsignininfo(local)
            setLoggedUser(local)
            // toast.success(res.data.Message);
            // navigate("/dashboard");
        } catch (error) {
            // console.error(error);
            const errorMessage = error.response?.data?.message || "Login failed. Please try again.";
            setError(errorMessage);
            toast.error(errorMessage);
            console.log(error);

        } finally {
            setLoading(false);
        }


    };

    return (
        <div className="min-h-screen bg-[--primary-color] flex items-center justify-center p-4"
            id='primary-fonts'>
            <div className="bg-[--bg-color] rounded-2xl shadow-lg max-w-md w-full p-8 space-y-6">
                {/* Logo / Header */}
                <div className="flex flex-col items-center">
                    {/* Full-size or larger logo/banner */}
                    <img
                        src={image}
                        alt="Urdu Ustaad"
                        className="w-32 h-32 mb-4 "
                    />
                    <h1 className=" md:text-2xl text-[--text-color] mb-2">Welcome to Urdu Ustaad</h1>
                    <p className="text-gray-600 text-sm md:text-base">Please sign in to continue</p>
                </div>


                {/* Error message */}
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
                        {error}
                    </div>
                )}

                {/* Form */}
                <form className="space-y-4" onSubmit={handleSubmit}>
                    {/* Username */}
                    <div className="relative">
                        <FaUser className="absolute left-3 top-3 text-gray-400" />
                        <input
                            type="text"
                            name="username"
                            placeholder="Username"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[--border-color-o] focus:outline-none"
                            value={SigninCrediential.username}
                            onChange={handleChange}
                            disabled={loading}
                        />
                    </div>

                    {/* Password */}
                    <div className="relative">
                        <FaLock className="absolute left-3 top-3 text-gray-400" />
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[--border-color-o] focus:outline-none"
                            value={SigninCrediential.password}
                            onChange={handleChange}
                            disabled={loading}
                        />
                    </div>

                    {/* Submit */}
                    <button
                        type="submit"
                        className={`w-full bg-[--primary-btn-color] text-white font-semibold py-2 rounded-lg hover:bg-[--secondary-btn-color] transition duration-200 flex items-center justify-center ${loading ? 'opacity-75 cursor-not-allowed' : ''
                            }`}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Signing In...
                            </>
                        ) : (
                            'Sign In'
                        )}
                    </button>
                </form>  
            </div>
        </div>
    );
};

export default Signin;

